var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ open: _vm.showComments },attrs:{"data-tour":"toggle-comments"},on:{"click":_vm.toggleComments}},[_c('span',[_vm._v(_vm._s(_vm.commentsCount || ''))]),_c('icon',{attrs:{"name":"comment"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }